import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20panoramic%20cityscape%20at%20night%2C%20warm%20golden%20street%20lights%2C%20mysterious%20urban%20atmosphere%2C%20cinematic%20wide%20angle%2C%20dark%20sky%20with%20scattered%20clouds%2C%20no%20visible%20people%2C%20abstract%20editorial%20photography%2C%20rich%20amber%20and%20dark%20tones&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
          alt="爆料投稿"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 h-full flex items-center px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="pt-10 md:pt-0">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-none mb-6">
              有料
              <br />
              就爆
            </h2>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-background-50 text-foreground-950 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap"
            >
              立即投稿
              <span className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </Link>
          </div>

          <div className="pb-10 md:pb-0 md:text-right">
            <p className="text-sm md:text-base text-background-50/60 max-w-xs md:ml-auto leading-relaxed">
              你有独家爆料？你有不可告人的秘密？
              <br />
              来91吃瓜网，让你的声音被听到。
              <br />
              爆料投稿完全匿名，保护每一位爆料者。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}